/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'circle-arrow-bottom': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M17.07 2.93a9.998 9.998 0 00-14.14 0 9.998 9.998 0 000 14.14 9.998 9.998 0 0014.14 0 9.998 9.998 0 000-14.14zM14.9 8.181l-.669.668-2.92 2.92c-.612.61-1.222 1.222-1.831 1.832-.39.39-1.053.39-1.444 0-.12-.12-.24-.24-.357-.36l-2.533-2.538c-.403-.403-.375-1.036 0-1.444.373-.406 1.067-.377 1.444 0 .12.12.24.24.357.36.604.603 1.21 1.211 1.811 1.815l2.867-2.867 1.832-1.831c.403-.403 1.035-.376 1.444 0 .405.375.376 1.067-.001 1.445z" _fill="#27DBBD" fill-rule="evenodd"/>'
  }
})
